// libs
import React from "react";

// components
import { CircularProgress, Box } from "@mui/material";

// props
export interface CircularLoaderProps {
    size: number;
    height: number;
}

const CircularLoader: React.FC<CircularLoaderProps> = ({ size, height }) => {
    return (
        <Box height={height} display="flex" alignItems="center" justifyContent="center">
            <CircularProgress size={size} />
        </Box>
    );
};

export default React.memo(CircularLoader);
